export const NEED_NOT_FOUND_SUB_CODE = 'DETAIL_DATA_NOT_FOUND'

export function isNeedNotFoundFailed(resData: any) {
  return !resData || resData.subCode !== NEED_NOT_FOUND_SUB_CODE
}

export function getNeedNotFoundMessage(resData: any, fallback = '资源不存在') {
  return resData?.describe || resData?.message || resData?.msg || fallback
}

export function throwNotFoundError(message = '资源不存在') {
  throw createError({
    statusCode: 404,
    statusMessage: 'Not Found',
    message,
    fatal: true,
  })
}
